<template>
  <div class="redirect">
    <div class="title">
      <h3>Đang chuyển trang, vui lòng đợi trong giây lát...</h3>
    </div>
    <div class="loading">
      <div class="el-icon-loading"></div>
    </div>
  </div>
</template>

<script>
  import constants from "../../constants";
  import authenService from "../../services/authenService";
  import VueCookies from 'vue-cookies';
  import userAccessToken from "../../services/userAccessTokenService";
  import fcmService from "../../services/fcmService";

  export default {
    name: "Logout",

    created() {
      const localToken = fcmService.getFromLocalStorage();
      if (localToken) {
        this.unSubscribeFcm(localToken).then(() => {
          fcmService.removeDeviceToken();
          this.cleanToken();
          this.redirectToSSOPage();
        });
      }
      else {
        this.cleanToken();
        this.redirectToSSOPage();
      }
    },

    methods: {
      cleanToken(){
        let idToken = authenService.getIdToken();
        userAccessToken.cleanAccessToken(idToken)
      },
      unSubscribeFcm(localToken) {
          return fcmService.clearSessionToken(localToken)
      },
      redirectToSSOPage() {
        // userService.logoutAllApp();
        authenService.removeToken().then(() => {
          let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
          let redirect_uri = encodeURIComponent(constants.SSO_LOGOUT_CALLBACK);
          VueCookies.remove("IdHash");


          let tenantCode = '';
          if(window.location.hostname) {
              tenantCode = window.location.hostname.split('.')[0];
          }
          // if(window.location.pathname) {
          //   tenantCode = window.location.pathname.split('/')[1];
          // }

          let sessionId = encodeURIComponent(authenService.getSessionId());
          let userId = encodeURIComponent(authenService.getUSID());
          window.location.href = `${// constants.BASE_SERVICE_DOMAIN +tenantCode+'.'+
            constants.SSO_URL_LOGOUT
          }?client_id=${client_id}&redirect_uri=${redirect_uri}&tenant_code=${tenantCode}&userId=${userId}&sessionId=${sessionId}`;
        });
      }
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/Logout.vue